/****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ContentService } from '../../../core/services/content.service';
import { CustomOverlayService } from '../../../core/services/custom-overlay.service';
import { HeaderService } from '../../../core/services/header.service';
import { config } from '../../ba-supplier-config';
import { Constants } from '../../ba-supplier-ui.constants';
import { SupplierACLService } from '../../services/supplier-acl-service';
import { ProfileService } from '../../../core/services/profile.service';


@Component({
    selector: 'app-supp-home',
    templateUrl: './supp-home.component.html',
    styleUrls: ['./supp-home.component.scss'],
    standalone: false
})
export class SuppHomeComponent implements OnInit {
  language = Constants.LANGUAGE;
  isAppBusy;
  showSpinner: boolean;
  appDataLoaded: boolean = false;

  constructor(
    private translate: TranslateService,
    private _header: HeaderService,
    private _content: ContentService,
    private _overlay: CustomOverlayService,
    private _aclService: SupplierACLService,
    private _profileService: ProfileService
  ) {
  }

  ngOnInit() {
    //this._header.changeTitle(config.headerTitle);
    
    this._header.replaceIcons(config.icons);
    this._content.chatEnabled(config.hasChatBox);
    this._overlay.changeMenuItems(config.staticMenuOptions);
    this._profileService.setAppPermissions('SUP', (err) => {
      this.appDataLoaded = true;
      this._header.changeLogo(null,null,true);
    });

    // this._aclService.getSideBarMenus().subscribe((result) => {
    //   this._header.changeMenuItems(result);
    // });
  }
}


